import * as e from "react";
import p from "../lib/IconBase.es.js";
import c from "../defs/Paperclip.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(p, { ref: a, ...r, weights: c }));
o.displayName = "PaperclipIcon";
const m = o;
export {
  m as Paperclip,
  o as PaperclipIcon
};
